export const SET_OFFERS = 'set-offers';
export const CLEAR_OFFERS = 'clear-offer';
